var _path, _g, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ProfileIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 41,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D66FC",
    d: "M0 16.27h40.088v24.255H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ProfileIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.043,
    cy: 20.847,
    r: 19.668,
    fill: "#0D66FC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.013 23.344a7.388 7.388 0 0 1-1.846 2.871 7.385 7.385 0 0 1-5.292 2.089 7.388 7.388 0 0 1-5.219-2.267 7.425 7.425 0 0 1-1.619-2.558l-4.646 1.968a12.485 12.485 0 0 0 2.641 4.093 12.393 12.393 0 0 0 8.756 3.803h.218c3.25 0 6.32-1.238 8.663-3.503a12.423 12.423 0 0 0 3.023-4.606l-4.68-1.89Z",
    fill: "#F5CCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 5.137h11.392H20.3Zm0 0H8.39 20.3ZM20.382 9.094h14.727-14.727Zm0 0H4.984h15.398ZM20.18 1.18h5.867-5.867Zm0 0h-6.133 6.133ZM20.436 13.05h17.11-17.11Zm0 0H2.546h17.89Z",
    stroke: "#2576FF",
    strokeWidth: 1.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgProfileIcon;